import request from "@/util/axios";
import { mall_wx_get_user_info } from "./login";

// 获取短信验证码
export function send_validate_code_sms(mobile) {
  return request({
    url: "/mall/wx/wx-user-send-validate-code-sms",
    params: { mobile },
  });
}

// 验证短信验证码
export function validateSmsCode(mobile, code, payPwd) {
  return request({
    url: `/mall/wx/wx-user-validate-sms-code`,
    params: { mobile, code, payPwd },
  });
}

// 只验证短信验证码，返回成功还是失败
export function validateCode(mobile, code) {
  return request({
    url: `/mall/wx/wx-user-validateCode`,
    params: { mobile, code },
  });
}

// 通过手机号激活绑定的卡券
export function activeUserCards() {
  return request({
    url: `/mall/wx/UserCenter/active-user-cards`,
  });
}

// 更新用户cityCode
export function updateUserCityCode(cityCode, cityName, poi) {
  return request({
    url: `/mall/wx/WxUser/updateUserCityCode`,
    params: { cityCode, cityName, poi },
  });
}

// 微信扫一扫
export function wx_get_jsapi_ticket(url) {
  return request({
    url: `/v5/get-jsapi-ticket`,
    params: { url },
    method: "post",
  });
}

// 用户激活卡
export function bindCard(cardno, pwd, key) {
  return request({
    url: `/mall/wx/wx-user-bind-card`,
    params: { cardno, pwd, key },
  });
}

export function api_get_bind_cards(cityCode, cateId, topicId = 0, tradeno) {
  return request({
    url: `/mall/wx/wx-user-get-bind-cards`,
    params: { cityCode, cateId, topicId, tradeno },
  });
}

export function get_my_allow_use_cards_count() {
  return request({
    url: `/mall/wx/wx-user-get-my-allow-use-cards-count`,
  });
}

export function getCardDetail(cardId) {
  return request({
    url: `/mall/wx/wx-user-get-card-detail`,
    params: { cardId },
  });
}

export function getCardLog(cardId) {
  return request({
    url: `/mall/wx/wx-user-get-card-log`,
    params: { cardId },
  });
}

export function mall_WxUser_getMyCards() {
  return request({
    url: `/mall/wx/wx-user-get-my-cards`,
  });
}

// 用户地址
export function getAddressList() {
  return request({
    url: `/mall/wx/wx-user-get-address-list`,
  });
}

export function get_default_address() {
  return request({
    url: `/mall/wx/wx-user-get-default-address`,
  });
}

export function getAddress(addressId) {
  return request({
    url: `/mall/wx/wx-user-getAddress`,
    params: { addressId },
  });
}

export function getJdAreaList(areaId, level) {
  return request({
    url: `/mall/wx/wx-user-get-jd-area-list`,
    params: { areaId, level },
  });
}

export function mall_WxUser_save_address(data) {
  return request({
    url: `/mall/wx/wx-user-save-address`,
    data: data,
    method: "post",
  });
}

export function deleteAddress(addressId) {
  return request({
    url: `/mall/wx/wx-user-deleteAddress`,
    params: { addressId },
  });
}

/**
 * 获取当前用户认证信息列表
 * @returns {[{identityId:number,name:string,cardId:string,mobile:string,address:string}]}
 * @returns {string} name 项目
 * @returns {string} cardId 身份证号码
 */
export function getIdentityList() {
  return mall_wx_get_user_info().then(() => {
    return request({
      url: `/mall/wx/wx-user-get-identity-list?1`,
    });
  });
}

export function getUserIdentityList() {
  return request({
    url: `/mall/wx/wx-user-get-identity-list?2`,
  });
}

/**
 * 添加认证信息
 * @param data {[{name:string,cardId:string,mobile:string,address:string}]}
 * @returns {AxiosPromise}
 */
export function addIdentity(data) {
  return request({
    url: `/mall/wx/wx-user-add-identity`,
    data: data,
    method: "post",
  });
}

/**
 * 删除认证信息
 * @param identityId
 * @returns {AxiosPromise}
 */
export function deleteIdentity(identityId) {
  return request({
    url: `/mall/wx/wx-user-delete-identity`,
    params: { identityId },
  });
}

/**
 * 修改认证信息
 * @param data
 * @returns {AxiosPromise}
 */
export function modifyIdentity(data) {
  return request({
    url: `/mall/wx/wx-user-modify-identity`,
    data: data,
    method: "post",
  });
}

/**
 * 是否能打开指定频道
 * @param cateId
 * @returns {AxiosPromise}
 */
export function toChannelIndex(cateId) {
  return request({
    url: `/mall/wx/wx-user-to-channel-index`,
    params: { cateId },
    method: "get",
  });
}

/**
 * 指定类别是否被禁止显示
 * @param cateId
 * @returns {AxiosPromise}
 */
export function getCateIsBan(cateId) {
  return request({
    url: `/mall/wx/wx-user-get-cate-is-ban`,
    params: { cateId },
    method: "get",
  });
}
